<template>
  <div class="item ">
    <router-link :to="UrlLink"><a>{{RipeavMore}}</a></router-link>
  </div>
</template>

<script>
  export default {
    name: "RipeavMore",
    props:{
      RipeavMore:{},
      UrlLink:{},
    },
  }
</script>

<style lang="less" scoped>
.item{
  width: 152px;
  height: 50px;
  border-radius: 2px;
  border: 1px solid #CCCCCC;
  &:hover{
    span{
      color: #188ACB;
    }
    border: 1px solid #188ACB;
  }
  a{
    text-decoration: none;
    width: 72px;
    height: 18px;
    font-size: 18px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #666666;
    line-height: 50px;
  }
}

</style>